//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { DataTypeGroupComponent } from "../../helpers"
import { Enums } from '../../models/common'
import { OpDataTypeInGroup } from '../../models/core'

import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../user-session'


//#region Public Types

export const DATA_TYPE_GROUP_SERVICE_NAME = 'DataTypeGroupService'
export const DATA_TYPE_GROUP_SERVICE_PROVIDER_NAME = 'DataTypeGroupServiceProvider'

//#endregion


//#region Private Types

type GetDataTypeInGroupOptions = {

    /**
     * Reference type for which the groups should be search for.
     */
    groupReferenceType?: Enums.ReferenceType,

    /**
     * Reference value for which the groups should be search for.
     */
    groupReferenceValue?: number,
}

//#endregion


export class DataTypeGroupService {

    //#region Ctor

    constructor(private userSessionService: UserSessionService) { }

    //#endregion


    //#region Public Methods

    public getDataTypeInGroupByCategory(dataTypeGroupCategory: Enums.SimaxDataTypeGroupCategory, moduleName: Enums.SimaxModuleName, options?: GetDataTypeInGroupOptions): JQueryPromise<OpDataTypeInGroup[]>
    public getDataTypeInGroupByCategory(dataTypeGroupCategories: Enums.SimaxDataTypeGroupCategory[], moduleName: Enums.SimaxModuleName, options?: GetDataTypeInGroupOptions): JQueryPromise<OpDataTypeInGroup[]>
    public getDataTypeInGroupByCategory(dataTypeGroupCategory: Enums.SimaxDataTypeGroupCategory | Enums.SimaxDataTypeGroupCategory[], moduleName: Enums.SimaxModuleName, options: GetDataTypeInGroupOptions = {}): JQueryPromise<OpDataTypeInGroup[]> {

        if (dataTypeGroupCategory == null || moduleName == null) {
            return $.Deferred<OpDataTypeInGroup[]>().resolve([]).promise()
        }

        const categories: Enums.SimaxDataTypeGroupCategory[] = _.isArray(dataTypeGroupCategory) ? dataTypeGroupCategory : [dataTypeGroupCategory]
        let groupReferenceType: Enums.ReferenceType = null
        let groupReferenceValue: number = null

        if (options != null) {
            groupReferenceType = options.groupReferenceType
            groupReferenceValue = options.groupReferenceValue
        }

        const promiseList: JQueryPromise<OpDataTypeInGroup[]>[] = _.map(categories, (dataTypeGroupCategory: Enums.SimaxDataTypeGroupCategory) => {
            return DataTypeGroupComponent.getDataTypeInGroupByModule(this.userSessionService.getDataProvider(), dataTypeGroupCategory, moduleName, groupReferenceType, groupReferenceValue)

        })

        return $.when(...promiseList)
    }


    /**
     * Find a Reference Type of a Data Type Group, that the given datatype is defined in.
     */
    public findReferenceTypeOfGroupsByDataType(idDataType: number, dataTypeInGroup: string, referenceType: Enums.ReferenceType, referenceValues: number[]): JQueryPromise<Enums.ReferenceType> {
        const deferredList: JQueryPromise<{ dataTypeInGroup: OpDataTypeInGroup[], referenceValue: number }>[] = []

        _.forEach(referenceValues, (referenceValue: number) => {
            const deferred = this.userSessionService
                .getDataProvider().DataTypeGroup
                .getDataTypeInGroup(dataTypeInGroup, referenceType, referenceValue)
                .then((dataTypeInGroupList: OpDataTypeInGroup[]) => {
                    return {
                        dataTypeInGroup: dataTypeInGroupList,
                        referenceValue
                    }
                })

            deferredList.push(deferred)
        })

        return $.when(...deferredList)
            .then((...result: any[]) => {
                let referenceType: number = null

                for (const grouping of result) {
                    if (
                        grouping != null &&
                        _.isArray(grouping.dataTypeInGroup) &&
                        grouping.dataTypeInGroup.some((dataTypeInGroup: OpDataTypeInGroup) => dataTypeInGroup.idDataType === idDataType)
                    ) {
                        referenceType = grouping.referenceValue
                    }
                }

                return referenceType
            })
    }

    //#endregion
}

export class DataTypeGroupServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSessionService: UserSessionService) {
        return new DataTypeGroupService(userSessionService)
    }]

    //#endregion
} 